import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  Type,
} from '@angular/core';
import {
  ALLOWED_INPUTS_BY_TYPE,
  CONTROL_TYPES,
} from '../../constants/form.constants';
import { ControlType } from '../../models/form.model';
import { ControlBase } from '../base/base.component';
import { NgComponentOutlet } from '@angular/common';

@Component({
  selector: 'form-control',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgComponentOutlet],
  template: `
    <ng-container
      *ngComponentOutlet="componentControl(); inputs: combinedInputs();">
    </ng-container>
  `,
})
export class ControlDynamicComponent extends ControlBase {
  private readonly CONTROLS = CONTROL_TYPES;
  private readonly DEFAULT_CONTROL_TYPE: ControlType = 'string';

  type = input<ControlType>(this.DEFAULT_CONTROL_TYPE);
  typeInputs = input<{ [key: string]: any }>({});

  componentControl = computed(() => this.getControl(this.type()));

  baseInputs = computed(() => ({
    label: this.label(),
    placeholder: this.placeholder(),
    control: this.control(),
  }));

  combinedInputs = computed(() => ({
    ...this.baseInputs(),
    ...this.filterTypeInputs(this.type(), this.typeInputs()),
  }));

  private getControl(type: ControlType): Type<unknown> | null {
    return this.CONTROLS[type] || null;
  }

  private filterTypeInputs(
    type: ControlType,
    inputs: { [key: string]: any },
  ): { [key: string]: any } {
    const allowedInputs = ALLOWED_INPUTS_BY_TYPE[type] || [];
    return Object.keys(inputs)
      .filter((key) => allowedInputs.includes(key))
      .reduce(
        (acc, key) => {
          acc[key] = inputs[key];
          return acc;
        },
        {} as { [key: string]: any },
      );
  }
}
